import Cookies from 'js-cookie';

const isDev = (process.env.NODE_ENV === 'development');

const host = () => {
	if ( isDev ) {
		return 'http://192.168.0.129:3000';
	}
	else {
		return 'https://v1covqp491.execute-api.us-east-2.amazonaws.com/latest';
	}
};

const getUserIDKey = () => {
	if ( isDev ) {
		return 'User-Id-Dev';
	}
	else {
		return 'User-Id';
	}
};

const getUserUniqueIDKey = () => {
	if ( isDev ) {
		return 'Unique-User-Id-Dev';
	}
	else {
		return 'Unique-User-Id';
	}
};

const isLoggedIn = () => {
	const userID = Cookies.get(getUserIDKey());
	const uniqueUserID = Cookies.get(getUserUniqueIDKey());

	if ( userID === undefined || uniqueUserID === undefined ) {
		return false;
	}

	return true;
};

const getHeaders = (contentType) => {
	if ( contentType == 'form' ) {
		contentType = 'multipart/form-data';
	}
	else {
		contentType = 'application/json';
	}

	let headers = {
		'Accept': 'application/json',
		'Content-Type': contentType,
	};

	const userID = Cookies.get(getUserIDKey());
	const uniqueUserID = Cookies.get(getUserUniqueIDKey());

	if ( userID !== undefined && uniqueUserID !== undefined ) {
		headers[getUserIDKey()] = userID;
		headers[getUserUniqueIDKey()] = uniqueUserID;
	}

	// console.log('headers',headers);
	return headers;
};

const getPostHeaders = () => {
	return getHeaders('json');
};

const getPostFormHeaders = () => {
	return getHeaders('form');
};

const parseResponse = async (response) => {
	const responseText = await response.text();

	let responseData = null;
	if (responseText !== '') {
		try {
			responseData = JSON.parse(responseText);
		}
		catch (error) {
			responseData = responseText;
		}
	}

	if (response.ok) {
		if (responseData === null) {
			return {};
		}

		return responseData;
	}

	let errorMessage = response.statusText || 'Request failed.';

	if (responseData && typeof responseData === 'object') {
		errorMessage = responseData.error || responseData.message || errorMessage;
	}
	else if (typeof responseData === 'string' && responseData.trim() !== '') {
		errorMessage = responseData;
	}

	throw new Error(errorMessage);
};

const sendRequest = async (url, jsonBody) => {
	return fetch(`${host()}${url}`, {
		method: 'POST',
		headers: getPostHeaders(),
		body: JSON.stringify(jsonBody),
		mode: 'cors',
	})
	.then(parseResponse)
	.catch(error => {
		console.log('----------req error: ' + url);
		console.log(error && error.message ? error.message : error);
		throw error;
	});
};

const sendFormRequest = async (url, formData) => {
	return fetch(`${host()}${url}`, {
		method: 'POST',
		headers: getPostFormHeaders(),
		body: formData,
		mode: 'cors',
	})
	.then(parseResponse)
	.catch(error => {
		console.log('----------req error: ' + url);
		console.log(error && error.message ? error.message : error);
		throw error;
	});
};

const uploadFileToSignedUrl = (signedUrl, file, options = {}) => {
	const {
		contentType,
		onProgress,
	} = options;

	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();

		xhr.open('PUT', signedUrl);

		if (typeof contentType === 'string' && contentType.trim() !== '') {
			xhr.setRequestHeader('Content-Type', contentType);
		}

		xhr.upload.onprogress = (event) => {
			if (!event.lengthComputable || typeof onProgress !== 'function') {
				return;
			}

			const uploadProgress = Math.min(100, Math.round((event.loaded / event.total) * 100));
			onProgress(uploadProgress);
		};

		xhr.onload = () => {
			if (xhr.status >= 200 && xhr.status < 300) {
				if (typeof onProgress === 'function') {
					onProgress(100);
				}
				resolve();
				return;
			}

			reject(new Error(`Upload failed (${xhr.status}).`));
		};

		xhr.onerror = () => {
			reject(new Error('Upload failed. Please try again.'));
		};

		xhr.send(file);
	});
};

const setAuthDetails = (userID, userUniqueID) => {
	Cookies.set(getUserIDKey(), userID.toString() );
	Cookies.set(getUserUniqueIDKey(), userUniqueID.toString() );
};

const removeAuthDetails = () => {
	Cookies.remove(getUserIDKey());
	Cookies.remove(getUserUniqueIDKey());
	Cookies.remove('email');
};

const setUserInfo = (userInfo) => {
	Cookies.set('email', userInfo.email);
};

const getUserEmail = () => {
	return Cookies.get('email');
};

export {
	isDev,

	sendRequest,
	sendFormRequest,
	uploadFileToSignedUrl,

	isLoggedIn,
	setAuthDetails,
	setUserInfo,
	getUserEmail,
	removeAuthDetails,
};